{
    "name": "shs-digi-care-monorepo",
    "version": "6.27.0-alpha.28",
    "license": "MIT",
    "packageManager": "npm@11.9.0",
    "scripts": {
        "nx": "nx",
        "test": "nx run-many --target test --all --parallel=3",
        "test:watch": "jest --watch",
        "frontend:lint": "nx run frontend:lint",
        "frontend:local": "nx run frontend:serve:local",
        "frontend:dev": "nx run frontend:serve",
        "frontend:qa": "nx run frontend:serve:qa",
        "frontend:explore-bundle-size": "nx run frontend:build:local --stats-json && webpack-bundle-analyzer dist/packages/frontend/local/stats.json",
        "prettier:check": "prettier --config .prettierrc --check '**/src/**/*.{ts,js,json,md}' --no-error-on-unmatched-pattern",
        "prettier:write": "prettier --config .prettierrc --write '**/src/**/*.{ts,js,json,md}' --no-error-on-unmatched-pattern",
        "prepare": "husky install",
        "postinstall": "node scripts/agent-sync.js sync --soft",
        "lint": "nx run-many --target lint --all --parallel=3",
        "typecheck": "nx run-many --target typecheck --all --parallel=3",
        "release": "semantic-release",
        "check": "nx run-many --target test --target typecheck --target lint --all --parallel=3",
        "check:full": "nx run-many --target test --target typecheck --target lint --target build --all --parallel=3 --configuration=dev",
        "audit": "npm audit --omit=dev --audit-level=high",
        "agent-sync": "node scripts/agent-sync.js",
        "env:local": "node scripts/generate-local-env.js",
        "sync:translation-keys": "node scripts/sync-translation-keys.js",
        "start:local": "node scripts/start-local.js",
        "migrate:local": "docker-compose up -d && npx -y concurrently -n \"user-service-api,contract-lifecycle-service,om-emea-service,request-service-api,analytics-service-api\" -c \"blue,green,yellow,magenta,cyan\" \"nx run user-service-api:migration:run-local\" \"nx run contract-lifecycle-service:migration:run-local\" \"nx run om-emea-service:migration:run-local\" \"nx run request-service-api:migration:run-local\" \"nx run analytics-service-api:migration:run-local\""
    },
    "private": true,
    "devDependencies": {
        "@angular-devkit/build-angular": "21.2.7",
        "@angular-devkit/core": "21.2.7",
        "@angular-devkit/schematics": "21.2.7",
        "@angular-eslint/eslint-plugin": "21.2.0",
        "@angular-eslint/eslint-plugin-template": "21.2.0",
        "@angular-eslint/template-parser": "21.2.0",
        "@angular/cli": "21.2.7",
        "@angular/compiler-cli": "21.2.25",
        "@angular/language-service": "21.2.25",
        "@aws-appsync/utils": "^2.0.3",
        "@aws-sdk/client-codebuild": "^3.993.0",
        "@commitlint/cli": "^19.5.0",
        "@commitlint/config-conventional": "^19.5.0",
        "@eslint/eslintrc": "^3.2.0",
        "@eslint/js": "^9.15.0",
        "@mrgrain/cdk-esbuild": "^5.3.5",
        "@nestjs/testing": "^11.1.16",
        "@ngxs/devtools-plugin": "^21.0.0",
        "@ngxs/logger-plugin": "^21.0.0",
        "@nx/angular": "22.6.5",
        "@nx/esbuild": "22.6.5",
        "@nx/eslint": "22.6.5",
        "@nx/eslint-plugin": "22.6.5",
        "@nx/jest": "22.6.5",
        "@nx/js": "22.6.5",
        "@nx/node": "22.6.5",
        "@nx/playwright": "22.6.5",
        "@nx/workspace": "22.6.5",
        "@playwright/test": "^1.60.0",
        "@schematics/angular": "21.2.7",
        "@semantic-release/changelog": "^6.0.3",
        "@semantic-release/commit-analyzer": "^13.0.1",
        "@semantic-release/git": "^10.0.1",
        "@semantic-release/npm": "^13.1.2",
        "@semantic-release/release-notes-generator": "^14.0.3",
        "@stylistic/eslint-plugin": "^2.9.0",
        "@swc-node/register": "~1.11.1",
        "@swc/core": "~1.15.24",
        "@swc/helpers": "~0.5.11",
        "@types/aws-lambda": "^8.10.119",
        "@types/eslint__eslintrc": "^2.1.2",
        "@types/jest": "30.0.0",
        "@types/node": "^24.10.13",
        "@types/typo-js": "^1.2.2",
        "@typescript-eslint/eslint-plugin": "8.48.0",
        "@typescript-eslint/parser": "8.48.0",
        "@typescript-eslint/utils": "8.48.0",
        "angular-eslint": "^21.0.1",
        "autoprefixer": "^10.4.20",
        "aws-cdk": "^2.1118.0",
        "aws-cdk-lib": "2.248.0",
        "constructs": "^10.2.68",
        "esbuild": "0.25.5",
        "esbuild-plugin-copy": "^2.1.1",
        "esbuild-plugin-tsc": "^0.4.0",
        "eslint": "^9.13.0",
        "eslint-config-prettier": "10.1.5",
        "eslint-plugin-playwright": "^2.12.1",
        "eslint-plugin-prettier": "^5.2.6",
        "fast-check": "^4.5.3",
        "globals": "^15.12.0",
        "husky": "^8.0.0",
        "jest": "30.2.0",
        "jest-preset-angular": "16.0.0",
        "jest-util": "30.2.0",
        "jsonc-eslint-parser": "^2.1.0",
        "ng-mocks": "^14.15.1",
        "ng-packagr": "21.2.0",
        "ngx-translate-testing": "^7.0.0",
        "nodemon": "^3.1.10",
        "nx": "22.6.5",
        "osls": "^3.62.1",
        "otplib": "^12.0.1",
        "postcss": "^8.4.49",
        "postcss-import": "~15.1.0",
        "postcss-preset-env": "~9.0.0",
        "postcss-url": "~10.1.3",
        "prettier": "~3.6.2",
        "semantic-release": "^24.2.5",
        "serverless-offline": "^13.9.0",
        "serverless-plugin-reducer": "^4.0.1",
        "serverless-webpack": "^5.13.0",
        "tailwindcss": "^3.4.15",
        "terser-webpack-plugin": "^5.3.10",
        "ts-jest": "29.4.6",
        "ts-node": "^10.9.1",
        "tsconfig-paths-webpack-plugin": "^4.2.0",
        "typescript": "5.9.3",
        "typescript-eslint": "8.48.0",
        "webpack-bundle-analyzer": "^5.2.0"
    },
    "dependencies": {
        "@angular/animations": "21.2.25",
        "@angular/cdk": "21.2.2",
        "@angular/common": "21.2.25",
        "@angular/compiler": "21.2.25",
        "@angular/core": "21.2.25",
        "@angular/forms": "21.2.25",
        "@angular/material": "21.2.2",
        "@angular/material-moment-adapter": "21.2.2",
        "@angular/platform-browser": "21.2.25",
        "@angular/platform-browser-dynamic": "21.2.25",
        "@angular/router": "21.2.25",
        "@automapper/classes": "^8.8.1",
        "@automapper/core": "^8.8.1",
        "@automapper/nestjs": "^8.8.1",
        "@aws-amplify/api": "^6.3.24",
        "@aws-crypto/sha256-js": "^5.2.0",
        "@aws-lambda-powertools/commons": "^2.16.0",
        "@aws-lambda-powertools/idempotency": "^2.16.0",
        "@aws-lambda-powertools/logger": "^2.16.0",
        "@aws-lambda-powertools/parameters": "^2.16.0",
        "@aws-lambda-powertools/tracer": "^2.16.0",
        "@aws-sdk/client-appconfigdata": "^3.993.0",
        "@aws-sdk/client-codecommit": "^3.993.0",
        "@aws-sdk/client-dynamodb": "^3.993.0",
        "@aws-sdk/client-eventbridge": "^3.993.0",
        "@aws-sdk/client-s3": "^3.993.0",
        "@aws-sdk/client-scheduler": "^3.993.0",
        "@aws-sdk/client-secrets-manager": "^3.993.0",
        "@aws-sdk/client-sfn": "^3.993.0",
        "@aws-sdk/client-sqs": "^3.993.0",
        "@aws-sdk/client-ssm": "^3.993.0",
        "@aws-sdk/client-translate": "^3.993.0",
        "@aws-sdk/credential-provider-node": "^3.972.0",
        "@aws-sdk/rds-signer": "^3.993.0",
        "@aws-sdk/s3-presigned-post": "^3.993.0",
        "@aws-sdk/s3-request-presigner": "^3.993.0",
        "@aws-sdk/util-dynamodb": "^3.993.0",
        "@azure/identity": "^4.7.0",
        "@fastify/aws-lambda": "^5.1.4",
        "@fastify/static": "^10.0.0",
        "@fastify/swagger": "^9.4.2",
        "@foundation/juno-sdk": "file:npm-packages/foundation/foundation-juno-sdk-1.7.0.tgz",
        "@microsoft/microsoft-graph-client": "^3.0.7",
        "@nestjs/axios": "^4.0.0",
        "@nestjs/common": "^11.1.16",
        "@nestjs/config": "^4.0.0",
        "@nestjs/core": "^11.1.16",
        "@nestjs/passport": "^11.0.5",
        "@nestjs/platform-fastify": "^11.1.16",
        "@nestjs/schematics": "^11.0.9",
        "@nestjs/swagger": "^11.1.3",
        "@nestjs/typeorm": "^11.0.0",
        "@ngx-translate/core": "^16.0.0",
        "@ngx-translate/http-loader": "^8.0.0",
        "@ngxs/router-plugin": "^21.0.0",
        "@ngxs/storage-plugin": "^21.0.0",
        "@ngxs/store": "^21.0.0",
        "@shui/angular": "file:npm-packages/shui/angular-1.34.0.tgz",
        "@shui/core": "file:npm-packages/shui/core-1.35.0.tgz",
        "@smithy/protocol-http": "^5.0.1",
        "@smithy/signature-v4": "^5.0.1",
        "@tiptap/core": "^3.22.3",
        "@tiptap/extension-link": "^3.22.3",
        "@tiptap/extension-placeholder": "^3.22.3",
        "@tiptap/extension-table": "^3.22.3",
        "@tiptap/extension-table-cell": "^3.22.3",
        "@tiptap/extension-table-header": "^3.22.3",
        "@tiptap/extension-table-row": "^3.22.3",
        "@tiptap/extension-underline": "^3.22.3",
        "@tiptap/starter-kit": "^3.22.3",
        "ag-grid-angular": "^35.1.0",
        "angular-auth-oidc-client": "^21.0.1",
        "autoprefixer": "^10.4.20",
        "aws-amplify": "^6.4.0",
        "aws-jwt-verify": "^5.0.0",
        "axios": ">=1.15.2",
        "class-transformer": "^0.5.1",
        "class-validator": "0.14.1",
        "css-vars-ponyfill": "^2.4.8",
        "date-fns": "^4.1.0",
        "date-fns-tz": "^3.2.0",
        "echarts": "^5.5.1",
        "email-validator": "^2.0.4",
        "fastify": "5.12.7",
        "html-to-text": "^9.0.5",
        "jest-environment-jsdom": "^30.2.0",
        "ksuid": "^3.0.0",
        "libphonenumber-js": "^1.12.30",
        "moment": "^2.29.4",
        "mongodb": "^6.13.0",
        "ngx-echarts": "^20.0.0",
        "ngx-tiptap": "^14.0.1",
        "passport": "^0.7.0",
        "passport-custom": "^1.1.1",
        "pg": "^8.11.3",
        "postcss": "^8.4.49",
        "reflect-metadata": "^0.2.2",
        "rxjs": "^7.8.2",
        "tslib": "^2.5.0",
        "typeorm": "^0.3.31",
        "typo-js": "1.2.4",
        "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
        "zod": "^4.6.5",
        "zone.js": "0.16.0"
    },
    "overrides": {
        "@shui/angular": {
            "@angular/core": "^21.0.0",
            "@angular/common": "^21.0.0",
            "@shui/core": "$@shui/core",
            "rxjs": "$rxjs"
        },
        "ng-mocks": {
            "@angular/core": "$@angular/core",
            "@angular/common": "$@angular/common",
            "@angular/forms": "$@angular/forms",
            "@angular/router": "$@angular/router",
            "@angular/platform-browser": "$@angular/platform-browser",
            "rxjs": "$rxjs"
        },
        "@automapper/classes": {
            "reflect-metadata": "^0.2.2"
        },
        "@automapper/nestjs": {
            "@nestjs/common": "^11.0.0",
            "@nestjs/core": "^11.0.0",
            "rxjs": "$rxjs"
        },
        "@nestjs/platform-fastify": {
            "@fastify/static": "^10.0.0"
        },
        "@nestjs/swagger": {
            "@fastify/static": "^10.0.0"
        },
        "minimatch": "^10.2.4",
        "babel-plugin-istanbul": {
            "minimatch": "^3.1.2"
        },
        "fast-xml-parser": ">=5.5.6",
        "picomatch": "4.0.4",
        "path-to-regexp": "8.4.0",
        "webpack-dev-server": {
            "path-to-regexp": "0.1.13"
        },
        "lodash": "4.18.1",
        "fastify": "$fastify",
        "tar": ">=7.5.12",
        "serialize-javascript": ">=7.0.5",
        "axios": "$axios",
        "form-data": ">=4.0.6",
        "js-yaml": "^4.3.0",
        "fast-uri": ">4.1.2",
        "xlsx": "$xlsx",
        "brace-expansion": ">=5.0.9",
        "find-my-way": ">=9.7.0",
        "ip-address": ">=10.4.0",
        "undici": ">=8.12.2",
        "@azure/msal-node": ">=7.1.1",
        "ts-morph": ">=27.0.0",
        "source-map-js": ">=1.2.2",
        "@ts-morph/common": "^0.29.0",
        "vite": "7.3.7",
        "follow-redirects": ">=1.16.2"
    }
}
